export const pageContentWidth = '1240px';
